<template>
  <section
    class="scroll content d-flex flex-column justify-content-between flex-nowrap align-item-stretch"
    id="ResultatListAsso"
  >
    <div class="header-content w-100" id="ResultatSearchAsso">
      <span class="title-level level-3 mb-3" role="heading" :aria-level="titleLevel">
        <small>{{ i18n.resultsRequest }} :</small>&nbsp;
        <span v-if="displayTotalResults">
          <strong>{{ totalRows }}</strong>
          {{ totalRows > 1 ? i18n.results : i18n.result }}
        </span>
      </span>
      <div v-if="noResults" class="alert alert-light" role="alert">
        <i class="fa fa-exclamation-circle" aria-hidden="true"></i>
        {{ i18n.noResult }}
      </div>
      <nav
        class="d-flex justify-content-center align-content-stretch mb-3 w-100"
        :aria-label="i18n.resultsRequest"
        aria-hidden="true"
      >
        <b-pagination
          id="pagination-top"
          v-if="displayPaginationBar"
          :value="currentPage"
          @change="onPageChange"
          :per-page="$store.state.ITEMS_PER_PAGE"
          :total-rows="totalRows"
          :hide-ellipsis="true"
        ></b-pagination>
        <p class="sr-only">
          {{ i18n.resultsNumber }} :
          <strong>{{ currentPage }}</strong>
          {{ i18n.of }} {{ totalRows }}
        </p>
      </nav>
    </div>

    <div class="well-content d-flex flex-column align-item-stretch flex-grow-1" id="listAsso">
      <ul v-if="isLoading" aria-live="polite" :aria-label="i18n.loading" tabindex="-1" class="list-card">
        <vignette-loading v-for="n in lastLengthAvailable" :key="n"></vignette-loading>
      </ul>
      <ul v-else aria-live="off" class="list-card">
        <vignette v-for="association in associations" :key="association.id" :association="association"></vignette>
      </ul>
    </div>

    <div class="footer-content w-100 mb-2">
      <nav
        class="d-flex justify-content-center align-content-stretch align-items-center mb-3"
        :aria-label="i18n.resultsRequest"
      >
        <b-pagination
          id="pagination-bottom"
          v-if="displayPaginationBar"
          :value="currentPage"
          @change="onPageChange"
          :per-page="$store.state.ITEMS_PER_PAGE"
          :total-rows="totalRows"
          :hide-ellipsis="true"
        ></b-pagination>
        <button
          id="scrollTop"
          v-if="isScrollBtnShown"
          v-scroll-to="{
            el: '#ResultatListAsso',
            container: '#page-container',
            duration: 500,
            easing: 'linear',
            force: true,
          }"
          class="btn btn-primary floating-btn"
          :aria-label="i18n.returnPageHead"
        >
          <i class="fa fa-angle-double-up" aria-hidden="true"></i>
        </button>
      </nav>
    </div>
  </section>
</template>

<script>
import Vignette from '@/components/vignette/Vignette.vue';
import VignetteLoading from '@/components/vignette/VignetteLoading.vue';
import { BPagination } from 'bootstrap-vue';
import VueScrollTo from 'vue-scrollto';
import { titleLevelHelper } from '@/helpers/index.js';

export default {
  components: {
    Vignette,
    VignetteLoading,
    BPagination,
  },
  directives: {
    scrollTo: VueScrollTo,
  },
  props: {
    displayTotalResults: {
      type: Boolean,
      default: true,
    },
    isScrollBtnShown: {
      type: Boolean,
      required: true,
    },
  },
  computed: {
    associations() {
      return this.$store.state.associations;
    },
    /**
     * The pagination bars are only displayed if the total amount of
     * association is greater than the amount we display on one page
     *
     * ex: If there are 13 associations, the pagination is displayed
     */
    displayPaginationBar() {
      return this.$store.state.total > this.$store.state.ITEMS_PER_PAGE;
    },
    /**
     * Used by the pagination component to calculate
     * how many pagination button is needed
     */
    totalRows() {
      return this.$store.state.total;
    },
    currentPage() {
      return this.$store.state.currentPage;
    },
    /**
     * Will trigger the loading animation
     */
    isLoading() {
      return this.$store.state.loading;
    },
    noResults() {
      return this.$store.state.total === 0;
    },
    /**
     * This property is used to know how many Vignette were displayed before a
     * new search was triggered, the result allow us to display *n* loading
     * vignette if *n* vignette were previously displayed
     * So if 8 Vignette is currently on the screen and we trigger a new
     * search, 8 Loading Vignette will be displayed during loading
     */
    lastLengthAvailable() {
      if (this.associations.length < this.$store.state.ITEMS_PER_PAGE) return this.associations.length;
      return this.$store.state.ITEMS_PER_PAGE;
    },
  },
  methods: {
    /**
     * Handle page change
     */
    onPageChange(newPage) {
      if (newPage === this.$store.state.currentPage) return; //Nothing happens if we click on the current page
      this.$store.dispatch('setCurrentPage', newPage);
    },
  },
  data: function() {
    return {
      i18n: {
        label: this.$t(`activites.label`),
        resultsRequest: this.$t(`resultsRequest`),
        results: this.$t(`results`),
        result: this.$t(`result`),
        resultsNumber: this.$t(`resultsNumber`),
        noResult: this.$t(`noResult`),
        returnPageHead: this.$t(`returnPageHead`),
        loading: this.$t(`loading`),
        closeError: this.$t(`closeError`),
        of: this.$t('of'),
      },
      titleLevel: titleLevelHelper.computeTitleLevel(2),
    };
  },
};
</script>

<style lang="less">
@import 'pagination.less';
</style>

<style lang="less" scoped>
@import 'list-card.less';
</style>
